module.exports = __webpack_public_path__ + "img/Nba2k20_logo.5b51d5f5.png";